module.exports = __webpack_public_path__ + "img/Flip Card 2.e84711d2.svg";